var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowBottom = function SvgArrowBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m10 19.06 6.81-6.81h-6.06V1h-1.5v11.25H3.19zm-3.19-5.31h6.38L10 16.94z",
    clipRule: "evenodd"
  })));
};
export { SvgArrowBottom as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS45OTk5MSAxOS4wNjA1TDE2LjgxMDggMTIuMjVMMTAuNzUwMyAxMi4yNDk5TDEwLjc1MDMgMC45OTk5ODVIOS4yNTAyOUw5LjI1MDI5IDEyLjI0OTlMMy4xODk0NSAxMi4yNDk5TDkuOTk5OTEgMTkuMDYwNVpNNi44MTA3MyAxMy43NDk5TDEzLjE4OTQgMTMuNzVMOS45OTk5NiAxNi45MzkyTDYuODEwNzMgMTMuNzQ5OVoiLz4KPC9zdmc+Cg==";